module.exports = "<div class=\"map\">\n    <div class=\"map__control-container\" #mapElement ngNonBindable><div class=\"map__control\"></div></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/geo/ovs-map.component.html
// module id = ../../../../../src/app/shared/geo/ovs-map.component.html
// module chunks = main